const kibibyte = 1024;
const mebibyte = 1024 * kibibyte;
const gibibyte = 1024 * mebibyte;
const tebibyte = 1024 * gibibyte;
const pebibyte = 1024 * tebibyte;
const exbibyte = 1024 * pebibyte;
const zebibyte = 1024 * exbibyte;
const yobibyte = 1024 * zebibyte;

function formatBytes (bytes, unit, precision = 0) {
  switch (unit) {
  case 'B':
    return `${(bytes).toFixed(precision)} B`;
    break;
  case 'KiB':
    return `${(bytes / kibibyte).toFixed(precision)} KiB`;
    break;
  case 'MiB':
    return `${(bytes / mebibyte).toFixed(precision)} MiB`;
    break;
  case 'GiB':
    return `${(bytes / gibibyte).toFixed(precision)} GiB`;
    break;
  case 'TiB':
    return `${(bytes / tebibyte).toFixed(precision)} TiB`;
    break;
  case 'PiB':
    return `${(bytes / pebibyte).toFixed(precision)} PiB`;
    break;
  case 'EiB':
    return `${(bytes / exbibyte).toFixed(precision)} EiB`;
    break;
  case 'ZiB':
    return `${(bytes / zebibyte).toFixed(precision)} ZiB`;
    break;
  case 'YiB':
    return `${(bytes / yobibyte).toFixed(precision)} YiB`;
    break;
  }
  throw new Error('unknown unit');
}

function autoFormatBytes (bytes, precision = 0) {
  const units = [
    'B',
    'KiB',
    'MiB',
    'GiB',
    'TiB',
    'PiB',
    'EiB',
    'ZiB',
    'YiB'
  ];
  let maxSize = 1;
  for (let i = 0; i < units.length; ++i) {
    maxSize *= 1024;
    if (bytes < maxSize) {
      return formatBytes(bytes, units[i], precision);
    }
  }
  throw new Error('bytes too large');
}

module.exports = {
  formatBytes,
  autoFormatBytes
};



// WEBPACK FOOTER //
// ./src/packages/byte-utils/index.js